import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { InstagramIcon, ArrowUpRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  const {
    t
  } = useLanguage();
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-dark pt-24 pb-10 relative overflow-hidden" data-id="element-68">
      {/* Subtle warm glow at top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[200px] bg-sunset-gold/[0.03] rounded-full blur-[100px]" data-id="element-69" />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 relative z-10" data-id="element-70">
        {/* Top section */}
        <div className="flex flex-col items-center mb-18" data-id="element-71">
          <div className="flex items-center gap-5 mb-5" data-id="element-72">
            <div className="h-px w-10 bg-gradient-to-r from-transparent to-sand/30" data-id="element-73"></div>
            <span className="text-sand/60 text-[10px] font-medium tracking-[0.4em] uppercase" data-id="element-74">
              Restaurant
            </span>
            <div className="h-px w-10 bg-gradient-to-l from-transparent to-sand/30" data-id="element-75"></div>
          </div>
          <h3 className="font-serif text-3xl text-white mb-3 tracking-wide" data-id="element-76">
            El Astillero
          </h3>
          <p className="text-white/30 text-sm font-light max-w-xs text-center leading-relaxed" data-id="element-77">
            {t.hero.tagline}
          </p>
        </div>

        {/* Links grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-14 md:gap-8 mb-18" data-id="element-78">
          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-79">
            <h4 className="text-[10px] font-medium tracking-[0.35em] uppercase text-sand/70 mb-7" data-id="element-80">
              Enlaces
            </h4>
            <ul className="space-y-3.5 text-center md:text-left" data-id="element-81">
              {[{
              to: '/about',
              label: t.nav.about
            }, {
              to: '/menu',
              label: t.nav.menu
            }, {
              to: '/reservations',
              label: t.nav.reservations
            }, {
              to: '/gallery',
              label: t.nav.gallery
            }, {
              to: '/pool',
              label: t.nav.pool
            }, {
              to: '/contact',
              label: t.nav.contact
            }].map(link => <li key={link.to} data-id="element-82">
                  <Link to={link.to} className="text-white/40 hover:text-sand transition-colors duration-400 text-sm" data-id="element-83">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start" data-id="element-84">
            <h4 className="text-[10px] font-medium tracking-[0.35em] uppercase text-sand/70 mb-7" data-id="element-85">
              {t.nav.contact}
            </h4>
            <div className="text-center md:text-left text-white/40 text-sm space-y-3 font-light leading-relaxed" data-id="element-86">
              <p data-id="element-87">Urb. San Jorge S Casti, 152</p>
              <p data-id="element-88">43860 Sant Jordi d'Alfama, Tarragona</p>
              <p data-id="element-89">+34 655 14 81 65</p>
              <p data-id="element-90">info@elastillero.com</p>
            </div>
          </div>

          {/* Social */}
          <div className="flex flex-col items-center md:items-start" data-id="element-91">
            <h4 className="text-[10px] font-medium tracking-[0.35em] uppercase text-sand/70 mb-7" data-id="element-92">
              Síguenos
            </h4>
            <a href="https://www.instagram.com/elastillerosantjordi/" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2.5 text-white/40 hover:text-sand transition-colors duration-400 group" data-id="element-93">
              <InstagramIcon className="w-4 h-4" data-id="element-94" />
              <span className="text-sm" data-id="element-95">@elastillerosantjordi</span>
              <ArrowUpRightIcon className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-96" />
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/[0.06] flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-97">
          <p className="text-white/20 text-xs tracking-wider font-light" data-id="element-98">
            &copy; {currentYear} Restaurant el Astillero. {t.footer.rights}
          </p>
          <div className="flex space-x-8 text-xs text-white/20" data-id="element-99">
            <a href="#" className="hover:text-white/40 transition-colors duration-400" data-id="element-100">
              {t.footer.legal}
            </a>
            <a href="#" className="hover:text-white/40 transition-colors duration-400" data-id="element-101">
              {t.footer.privacy}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}